module.exports = __webpack_public_path__ + "img/PASSPORT.9a656d63.png";